import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface PollDetail {
  pollId: string;
  createdBy: string;
  title: string;
  description: string | null;
  questions: Array<{
    questionId: string;
    text: string;
    type: string;
    options?: string[];
    required: boolean;
  }>;
  resultsVisibility: string;
  status: string;
  closesAt: string | null;
  responseCount: number;
  hasResponded: boolean;
  isCreator: boolean;
  createdAt: string;
  updatedAt: string;
}

interface UsePollReturn {
  poll: PollDetail | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function usePoll(pollId: string | undefined): UsePollReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.polls.detail(pollId!),
    queryFn: () => api.getPoll(pollId!),
    enabled: !!pollId,
  });

  return {
    poll: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load poll' : null,
    refresh: () => {
      refetch();
    },
  };
}
